/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar) {
    'use strict';

    angular.module('ecTable').directive('ecTableCellLight', ["$parse", "mstarTemplate", "$window", function ($parse, mstarTemplate, $window) {
        return {
            restrict: 'A',
            link: function link(scope, element, attr) {
                var isHeader = element[0].tagName === 'TH';

                scope.$evalAsync(function () {
                    var template = getTemplate(isHeader, scope.field.fieldSettings.headerTemplate, scope.field.fieldSettings.itemTemplate);

                    if (isHeader) {
                        element.addClass(scope.field.fieldSettings.headerClass);
                        if (!scope.field.fieldName) {
                            scope.field.sortingEnabled = false;
                        }

                        if (parseInt(scope.field.fieldSettings.headerRowspan, 10) > 0) {
                            element.attr('rowspan', scope.field.fieldSettings.headerRowspan);
                        }

                        if (parseInt(scope.field.fieldSettings.headerColspan, 10) > 0) {
                            element.attr('colspan', scope.field.fieldSettings.headerColspan);
                        }
                    } else {
                        element.addClass(scope.field.fieldSettings.itemClass);
                    }

                    if (template) {
                        scope.$$watchers = scope.$$asyncQueue = scope.$$postDigestQueue = [];
                        mstarTemplate.compile(scope, element, { template: template, keepRootElement: false });
                    }
                });

                function getTemplate(isHeader, headerTemplate, itemTemplate) {
                    var template;
                    if (isHeader) {
                        if (headerTemplate === 'checkbox') {
                            template = scope.field.fieldSettings.checkboxHeaderTemplate;
                            scope.field.sortingEnabled = false;
                            element.addClass(scope.namespaceClass('__cell--checkbox-header'));
                        } else if (itemTemplate === 'hyperlink') {
                            scope.field.sortingEnabled = false;
                            template = headerTemplate;
                        } else {
                            template = headerTemplate;
                        }
                    } else {
                        if (itemTemplate === 'checkbox') {
                            template = scope.field.fieldSettings.checkboxItemTemplate;
                            element.removeClass(scope.namespaceClass('__cell--data'));
                            element.addClass(scope.namespaceClass('__cell--checkbox'));
                        } else if (itemTemplate === 'radio') {
                            template = scope.field.fieldSettings.radioItemTemplate;
                            element.removeClass(scope.namespaceClass('__cell--data'));
                            element.addClass(scope.namespaceClass('__cell--radio'));
                        } else if (itemTemplate === 'hyperlink') {
                            template = scope.field.fieldSettings.hyperlinkItemTemplate;
                            element.removeClass(scope.namespaceClass('__cell--data'));
                            element.addClass(scope.namespaceClass('__cell--hyperlink'));
                        } else if (itemTemplate === 'button') {
                            template = scope.field.fieldSettings.buttonItemTemplate;
                            element.removeClass(scope.namespaceClass('__cell--data'));
                            element.addClass(scope.namespaceClass('__cell--button'));
                        } else {
                            template = itemTemplate;
                        }
                    }

                    return template;
                }

                // todo(slind): the below could be used for static data tables to remove watchers after first bind
                // this does, however, require a track by keyFieldParsed in the table template
                //scope.$watchCollection('[obj, field.header]', function(newValue) {
                //    if ((isHeader || newValue[0]) && newValue[1]) {
                //        scope.$applyAsync(function() {
                //            scope.$destroy();
                //        });
                //    }
                //});

                scope.getHyperlinkText = function (obj, settings) {
                    var text = '';
                    if (settings.textField) {
                        text = morningstar.asterix.util.string.format(scope.labels.get(settings.text), obj[settings.textField]);
                    } else {
                        text = scope.labels.get(settings.text);
                    }

                    return text;
                };

                scope.getHyperlinkUrl = function (obj, settings) {
                    var url = '';
                    if (settings.urlFields) {
                        var args = [settings.url];
                        morningstar.asterix.util.each(settings.urlFields, function (field) {
                            args.push(encodeURIComponent(obj[field]));
                        });
                        url = morningstar.asterix.util.string.format.apply(this, args);
                    } else {
                        url = settings.url;
                    }

                    return url;
                };

                scope.openHyperlink = function (e) {
                    var a = element.find('a'),
                        url = a.attr('href'),
                        target = a.attr('target');
                    if (target) {
                        $window.open(url, target);
                    } else {
                        $window.open(url);
                    }
                    e.preventDefault();
                    e.stopPropagation();
                };
            }
        };
    }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar) {
    'use strict';

    angular.module('ecTable').directive('ecTableCell', ["$compile", "$parse", "mstarTemplate", "$window", function ($compile, $parse, mstarTemplate, $window) {
        return {
            restrict: 'A',
            link: function link(scope, element, attr) {
                var isHeader = element[0].tagName === 'TH';

                scope.$evalAsync(function () {
                    element.addClass(scope.namespaceClass('__cell'));

                    // hacky, but currently necessary, if (due to some instances having stickyLeadEnabled === true without any defined breakpoints)
                    if (scope.settings.get('stickyLeadEnabled') && (scope.settings.get('stickyLeadBreakPoints') || scope.settings.contains('_parameters.stickyLeadBreakPoints.binding'))) {
                        element.addClass(scope.namespaceClass('__cell--out-of-range'));
                    }

                    var template = getTemplate(isHeader, scope.field.fieldSettings.headerTemplate, scope.field.fieldSettings.itemTemplate);

                    if (isHeader) {
                        element.addClass(scope.field.fieldSettings.headerClass);
                        if (!scope.field.fieldName) {
                            scope.field.sortingEnabled = false;
                        }

                        if (parseInt(scope.field.fieldSettings.headerRowspan, 10) > 0) {
                            element.attr('rowspan', scope.field.fieldSettings.headerRowspan);
                        }

                        if (parseInt(scope.field.fieldSettings.headerColspan, 10) > 0) {
                            element.attr('colspan', scope.field.fieldSettings.headerColspan);
                        }
                    } else {
                        element.addClass(scope.field.fieldSettings.itemClass);
                    }

                    if (template) {
                        scope.$$watchers = scope.$$asyncQueue = scope.$$postDigestQueue = [];
                        mstarTemplate.compile(scope, element, { template: template, keepRootElement: false });
                    }
                });

                function getTemplate(isHeader, headerTemplate, itemTemplate) {
                    var template;
                    if (isHeader) {
                        if (headerTemplate === 'checkbox') {
                            template = scope.field.fieldSettings.checkboxHeaderTemplate;
                            scope.field.sortingEnabled = false;
                            element.addClass(scope.namespaceClass('__cell--checkbox-header'));
                        } else if (itemTemplate === 'hyperlink') {
                            scope.field.sortingEnabled = false;
                            template = headerTemplate;
                        } else {
                            template = headerTemplate;
                        }
                    } else {
                        if (itemTemplate === 'checkbox') {
                            template = scope.field.fieldSettings.checkboxItemTemplate;
                            element.removeClass(scope.namespaceClass('__cell--data'));
                            element.addClass(scope.namespaceClass('__cell--checkbox'));
                        } else if (itemTemplate === 'radio') {
                            template = scope.field.fieldSettings.radioItemTemplate;
                            element.removeClass(scope.namespaceClass('__cell--data'));
                            element.addClass(scope.namespaceClass('__cell--radio'));
                        } else if (itemTemplate === 'hyperlink') {
                            template = scope.field.fieldSettings.hyperlinkItemTemplate;
                            element.removeClass(scope.namespaceClass('__cell--data'));
                            element.addClass(scope.namespaceClass('__cell--hyperlink'));
                        } else if (itemTemplate === 'button') {
                            template = scope.field.fieldSettings.buttonItemTemplate;
                            element.removeClass(scope.namespaceClass('__cell--data'));
                            element.addClass(scope.namespaceClass('__cell--button'));
                        } else {
                            template = itemTemplate;
                        }
                    }

                    return template;
                }

                // todo(slind): the below could be used for static data tables to remove watchers after first bind
                // this does, however, require a track by keyFieldParsed in the table template
                //scope.$watchCollection('[obj, field.header]', function(newValue) {
                //    if ((isHeader || newValue[0]) && newValue[1]) {
                //        scope.$applyAsync(function() {
                //            scope.$destroy();
                //        });
                //    }
                //});

                scope.$watchCollection('[field.header, keyFieldParsed, $last, $index]', function () {
                    if (scope.$last && scope.obj) {
                        element.addClass(scope.namespaceClass('__cell--last'));
                    } else {
                        element.removeClass(scope.namespaceClass('__cell--last'));
                    }

                    if (scope.settings.get('orientation') !== 'horizontal' || !isHeader) {
                        element.attr('data-col-index', (scope.settings.get('orientation') === 'horizontal' ? 1 : 0) + scope.$index);
                    } else {
                        element.attr('data-col-index', 0);
                    }

                    if (scope.keyFieldParsed) {
                        element.attr('data-key', scope.keyFieldParsed(scope.obj));
                    }

                    element.attr('data-title', scope.field.header);
                });

                scope.registerStickyCallback(updateStickyClasses);

                function updateStickyClasses() {
                    var stickyState = scope.parameters.stickyState;
                    if (stickyState && stickyState.stickyMode && stickyState.stickyColIndices) {
                        var colIndex = parseInt(element.attr('data-col-index'));
                        if (stickyState.stickyColIndices.indexOf(colIndex) >= 0) {
                            element.addClass(scope.namespaceClass('__cell--sticky'));
                            element.removeClass(scope.namespaceClass('__cell--unsticky'));
                            element.removeClass(scope.namespaceClass('__cell--out-of-range'));
                        } else {
                            if (stickyState.visibleIndices && stickyState.visibleIndices.indexOf(colIndex) >= 0) {
                                element.addClass(scope.namespaceClass('__cell--unsticky'));
                                element.removeClass(scope.namespaceClass('__cell--sticky'));
                                element.removeClass(scope.namespaceClass('__cell--out-of-range'));
                            } else {
                                element.removeClass(scope.namespaceClass('__cell--sticky'));
                                element.removeClass(scope.namespaceClass('__cell--unsticky'));
                                element.addClass(scope.namespaceClass('__cell--out-of-range'));
                            }
                        }
                    } else {
                        element.removeClass(scope.namespaceClass('__cell--sticky'));
                        element.removeClass(scope.namespaceClass('__cell--unsticky'));
                        element.removeClass(scope.namespaceClass('__cell--out-of-range'));
                    }
                }

                scope.getHyperlinkText = function (obj, settings) {
                    var text = '';
                    if (settings.textField) {
                        text = morningstar.asterix.util.string.format(scope.labels.get(settings.text), obj[settings.textField]);
                    } else {
                        text = scope.labels.get(settings.text);
                    }

                    return text;
                };

                scope.getHyperlinkUrl = function (obj, settings) {
                    var url = '';
                    if (settings.urlFields) {
                        var args = [settings.url];
                        morningstar.asterix.util.each(settings.urlFields, function (field) {
                            args.push(encodeURIComponent(obj[field]));
                        });
                        url = morningstar.asterix.util.string.format.apply(this, args);
                    } else {
                        url = settings.url;
                    }

                    return url;
                };

                scope.openHyperlink = function (e) {
                    var a = element.find('a'),
                        url = a.attr('href'),
                        target = a.attr('target');
                    if (target) {
                        $window.open(url, target);
                    } else {
                        $window.open(url);
                    }
                    e.preventDefault();
                    e.stopPropagation();
                };
            }
        };
    }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar) {
    'use strict';

    angular.module('ecTable').directive('ecTableFootNote', ["$compile", "$parse", "mstarTemplate", "$window", "$timeout", "$sce", function ($compile, $parse, mstarTemplate, $window, $timeout, $sce) {
        return {
            restrict: 'E',
            require: '^mstarComponentId',
            link: function link(scope, element, attr, mstarComponent) {
                // binds settings, labels, formatter and templates to scope properties
                mstarComponent.bindConfig(scope);

                scope.footNote.content = $sce.trustAsHtml(scope.footNote.content);
                var template = scope.footNote.template || mstarComponent.getSettings().get('_templates.footNoteItemTemplate');
                mstarTemplate.compile(scope, element, {
                    template: template,
                    keepRootElement: false
                });
            }
        };
    }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(8), __webpack_require__(0), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, _, morningstar, $) {
    'use strict';

    table.$inject = ["$parse", "mstarSort", "$interpolate", "mstarDimensions", "$timeout"];
    angular.module('ecTable', ['mstarCore', 'ecButton', 'ecPaginator', 'ngTouch', 'ecChosen', 'ecContainer']).directive('ecTable', table);

    function table($parse, mstarSort, $interpolate, mstarDimensions, $timeout) {
        return {
            restrict: 'E',
            require: ['mstarComponentId'],
            scope: {
                data: '=?tableData',
                footNotes: '=?footNotes'
            },
            link: linkFn,
            controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
                this.sort = function (field) {
                    $scope.instance.trigger('ecTableColumnSorted', [field]);
                    mstarSort.updateParameters($scope.parameters, field);
                };

                this.removeRow = function (row) {
                    $scope.data.splice($scope.data.indexOf(row), 1);
                };

                $scope.sort = this.sort;
                $scope.removeRow = this.removeRow;
            }]
        };

        function linkFn(scope, elem, attr, controllers) {
            var mstarComponent = controllers[0];

            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            var mainTemplateName = '_templates.main';
            if (attr.templateType) {
                switch (attr.templateType) {
                    case 'default':
                        break;
                    case 'light':
                        mainTemplateName = '_templates.light';
                        break;
                    default:
                        morningstar.asterix.instrumentation.logger.fatal(new Error('(ec-table) could not find template type: ' + attr.templateType));
                }
            }

            // compiles the main template
            mstarComponent.compileTemplate(scope, mainTemplateName);

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            var _stickyCallbacks = [];
            scope.registerStickyCallback = function registerStickyCallback(cb) {
                _stickyCallbacks.push(cb);
            };

            // use model binding if no table-data attribute given, otherwise use table-data
            if (!attr.tableData) {
                mstarComponent.bindModelData(scope);
                if (scope.model) {
                    if (scope.model.rows && scope.model.rows.length) {
                        scope.data = scope.model.rows;
                    }

                    if (scope.model.footNotes && scope.model.footNotes.length) {
                        scope.footNotes = scope.model.footNotes;
                    }
                }
            } else {
                mstarComponent.bindModel(scope);
            }
            if (scope.settings.get('stickyLeadEnabled')) {
                stickyHandleNewSizeInDimensions();

                mstarDimensions(scope, elem).addListener(function (dimensions) {
                    scope.$evalAsync(function () {
                        stickyHandleNewSize(dimensions);
                    });
                });

                mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:stickyState.currentPage', function (colIndex) {
                    if (colIndex) {
                        scope.$evalAsync(function () {
                            stickyUpdateVisibleIndices();
                            scope.parameters.stickyState.onUpdated();
                        });
                    }
                }));

                mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:stickyLeadBreakPoints', function () {
                    scope.$evalAsync(function () {
                        stickyHandleNewSize(mstarDimensions(scope, elem).getDimensions());
                    });
                }));
            }

            scope.instance.setParameter('page', scope.instance.getParameter('defaultPage'));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:defaultPage', function (page) {
                if (page) {
                    scope.instance.setParameter('page', page);
                    if (scope.settings.get('stickyLeadEnabled')) {
                        scope.instance.setParameter('stickyState.currentPage', page);
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:page', function () {
                stickyHandleNewSizeInDimensions();
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:totalRows', function () {
                stickyHandleNewSizeInDimensions();
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:perPage', function () {
                stickyHandleNewSizeInDimensions();
            }));

            function stickyHandleNewSizeInDimensions() {
                mstarDimensions(scope, elem).requestDimensions(function (dimensions) {
                    scope.$evalAsync(function () {
                        stickyHandleNewSize(dimensions);
                    });
                });
            }

            function update() {
                // todo(slind): fixedTableHeader needs fixing
                if (scope.settings.get('fixedTableHeaderEnabled')) {
                    var tableElement = elem.find('.table');
                    if (tableElement) {
                        var fixedTableHeaderScrollContainer = scope.settings.get('fixedTableHeaderScrollContainer');
                        if (fixedTableHeaderScrollContainer) {
                            tableElement.floatThead({
                                scrollContainer: function scrollContainer(t) {
                                    return t.closest(fixedTableHeaderScrollContainer);
                                }
                            });
                        } else {
                            tableElement.floatThead();
                        }
                    }
                }

                fixStickyStatus();
            }

            scope.fieldCount = function () {
                return !scope.parameters.fields ? 0 : scope.parameters.fields.length;
            };

            scope.swipeLeft = function () {
                if (scope.settings.get('swipeBehavior') === 'page' && scope.settings.get('paginationMode') !== 'none') {
                    scope.parameters.page += 1;
                } else if (scope.settings.get('stickyLeadEnabled')) {
                    if (scope.parameters.stickyState && scope.parameters.stickyState.stickyMode) {
                        scope.parameters.stickyState.currentPage += 1;
                    }
                }
            };

            scope.swipeRight = function () {
                if (scope.settings.get('swipeBehavior') === 'page' && scope.settings.get('paginationMode') !== 'none') {
                    scope.parameters.page -= 1;
                } else if (scope.settings.get('stickyLeadEnabled')) {
                    if (scope.parameters.stickyState && scope.parameters.stickyState.stickyMode) {
                        scope.parameters.stickyState.currentPage -= 1;
                    }
                }
            };

            var _hasSetStickyOnUpdated = false;

            function stickyHandleNewSize(dimensions) {
                if (!scope.settings.get('stickyLeadEnabled')) {
                    return;
                }

                var stickyLeadBreakPoints = scope.parameters.stickyLeadBreakPoints;
                var stickyState = scope.parameters.stickyState = scope.parameters.stickyState || {};
                if (!_hasSetStickyOnUpdated) {
                    _hasSetStickyOnUpdated = true;
                    stickyState.onUpdated = function onUpdated() {
                        _.each(_stickyCallbacks, function (cb) {
                            cb();
                        });
                    };
                }

                if (!stickyLeadBreakPoints) {
                    stickyState.onUpdated();
                    return;
                }

                stickyState.stickyMode = false;
                for (var i = 0; i < stickyLeadBreakPoints.length; i++) {
                    if (dimensions.width >= stickyLeadBreakPoints[i].minWidth && dimensions.width <= stickyLeadBreakPoints[i].maxWidth) {
                        stickyState.stickyMode = true;
                        stickyState.columnsPerPage = stickyLeadBreakPoints[i].columnsPerPage;

                        stickyState.stickyColIndices = stickyLeadBreakPoints[i].stickyColIndices;
                    }
                }

                if (dimensions.width === 0) {
                    stickyState.stickyMode = true;
                }

                if (stickyState.stickyMode) {
                    if (!angular.isNumber(stickyState.currentPage)) {
                        stickyState.currentPage = scope.instance.getParameter('defaultPage') || 1;
                    }
                }

                stickyUpdateVisibleIndices();
                stickyState.onUpdated();
            }

            function stickyUpdateVisibleIndices() {
                var stickyState = scope.parameters.stickyState;
                if (!stickyState || !stickyState.stickyMode || !stickyState.stickyColIndices) {
                    return;
                }

                var tableColumns;
                if (scope.settings.get('orientation') === 'vertical') {
                    tableColumns = scope.parameters.fields;
                } else {
                    tableColumns = _.clone(scope.model.rows && scope.model.rows.length ? scope.model.rows : []);
                    //since the header will also be a column so add a placeholder for that
                    tableColumns.push({});
                }

                stickyState.visibleIndices = _.chain(tableColumns).map(function (f, i) {
                    return i;
                }).reject(function (n, i) {
                    return stickyState.stickyColIndices.indexOf(n) >= 0;
                }).filter(function (n, i) {
                    // note(slind): we could potentially want to change this to display a minimum number of columns instead of "true" pagination
                    return i >= (stickyState.currentPage - 1) * stickyState.columnsPerPage && i < stickyState.currentPage * stickyState.columnsPerPage;
                }).value();

                stickyState.totalNonStickyColumns = _.chain(tableColumns).map(function (f, i) {
                    return i;
                }).reject(function (n, i) {
                    return stickyState.stickyColIndices.indexOf(n) >= 0;
                }).value().length;
            }

            scope.defaultFieldSettings = scope.settings.get('defaultFieldSettings');

            if (scope.parameters.fields) {
                handleFields(scope.parameters.fields);
            }

            scope.$watchCollection('parameters.fields', handleFields);

            function handleFields(newValue) {
                angular.forEach(newValue, function prepareField(field, key) {
                    scope.parameters.fields[key] = field = morningstar.asterix.util.field.applyDefinitionsAndAliases(field, scope.settings.get('fieldDefinitions'), scope.settings.get('formatAliases'));

                    if (!field.fieldName) {
                        throw new Error('Missing field name for field: ' + JSON.stringify(field));
                    }

                    field.getter = $parse(field.fieldName);
                    field.header = field.headerLabelKey ? $interpolate(scope.labels.get(field.headerLabelKey))(scope) : field.header;
                    field.sortingEnabled = field.hasOwnProperty('sortingEnabled') ? field.sortingEnabled : scope.settings.get('sortingEnabled');
                    field.rearrangeEnabled = field.hasOwnProperty('rearrangeEnabled') ? field.rearrangeEnabled : scope.settings.get('columnsRearrangeEnabled');
                    field.fieldSettings = morningstar.asterix.util.merge({}, scope.defaultFieldSettings, field.fieldSettings);

                    if (!morningstar.asterix.util.isFunction(field.format)) {
                        if (field.format) {
                            field._originalFormat = field.format;
                        }

                        var _format = field.format || field._originalFormat;
                        field.formatDataType = _format ? _format.dataType : '';

                        field.format = function formatField(value) {
                            if (value || _format && _format.dataType) {
                                if (_format && _format.dataType === 'number') {
                                    return scope.format.number(value, _format);
                                } else if (_format && _format.dataType === 'date') {
                                    return scope.format.date(value, _format);
                                } else if (_format && _format.dataType === 'any') {
                                    return scope.format.any(value, _format);
                                } else {
                                    // todo(slind): implement formatters for other types (e.g. string, bool)
                                    return value;
                                }
                            } else {
                                return scope.settings.get('format.nullString') || value;
                            }
                        };
                    }

                    field.toggleExpandedRow = function toggleExpandedRow(row) {
                        row._displayingExpandedView = !row._displayingExpandedView;

                        if (row._displayingExpandedView) {
                            scope.instance.trigger('ecTableRowExpanded', [row]);
                        } else {
                            scope.instance.trigger('ecTableRowCollapsed', [row]);
                        }
                    };
                });

                scope.visibleFields = scope.parameters.fields;
                populateSortDropdown(scope.visibleFields);
                update();
            }

            function parseKeyField(keyField) {
                if (keyField && keyField.indexOf('{') > -1) {
                    scope.keyFieldParsed = $interpolate(keyField);
                } else {
                    scope.keyFieldParsed = $parse(keyField);
                }
            }

            var keyField = scope.instance.getParameter('keyField');
            parseKeyField(keyField);

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:keyField', function (newValue) {
                parseKeyField(newValue);
            }));

            if (scope.settings.get('standalone')) {
                var updateVisibleData = function updateVisibleData(newValue) {
                    if (angular.isUndefined(newValue)) {
                        return;
                    }

                    if (!scope.data || !angular.isArray(scope.data)) {
                        return;
                    }

                    if (scope.settings.get('expandAllRows')) {
                        expandAllRows();
                    }

                    scope.selectAll = false;

                    function checkIfFieldHasSortingEnabled(sortFieldName) {
                        var sortField = _.find(scope.parameters.fields, function (field) {
                            return field.fieldName === sortFieldName;
                        });
                        return sortField && sortField.sortingEnabled;
                    }

                    // need to be careful not to alter the watched properties here (will trigger double-updates)
                    var data = _.extend([], scope.data);
                    if (scope.settings.get('sortingEnabled') || checkIfFieldHasSortingEnabled(scope.parameters.sortField)) {
                        var sortFunc = scope.parameters.sortFunc;
                        if (sortFunc && scope.parameters.sortField) {
                            sortFunc = sortFunc[scope.parameters.sortField] || sortFunc;
                        }

                        if (morningstar.asterix.util.isFunction(sortFunc)) {
                            sortFunc(data, scope.parameters);
                        } else {
                            mstarSort.sort(data, scope.parameters, scope.settings.get('sortCaseInsensitive'));
                        }
                    }

                    scope.parameters.totalRows = data ? data.length : 0;
                    if (scope.settings.get('paginationMode') !== 'none') {
                        var paginationWindowSize = scope.parameters.paginationWindowSize || scope.parameters.perPage;
                        if (paginationWindowSize > scope.parameters.perPage) {
                            scope.logger.error(new Error('paginationWindowSize should not be greater than perPage value.'));
                        }
                        scope.visibleData = _.filter(data, function (e, i) {
                            return i >= (scope.parameters.page - 1) * paginationWindowSize && i < (scope.parameters.page - 1) * paginationWindowSize + scope.parameters.perPage;
                        });
                    } else {
                        scope.visibleData = data;
                    }
                    mstarComponent.getComponentInstance().setModelProperty('visibleRows', scope.visibleData);

                    update();
                };

                // shallow watch on data, to avoid triggering the watch if the data is modified in the table ui
                scope.$watchCollection('data', function (newValue) {
                    updateVisibleData(newValue);
                    if (scope.settings.get('enablePartialCheckbox')) {
                        updateGroupCheckbox();
                    }
                });

                scope.$watchCollection('[parameters.page, parameters.perPage, parameters.sortField, parameters.sortOrder]', function (newValue) {
                    updateVisibleData(newValue);
                    if (scope.settings.get('enablePartialCheckbox')) {
                        updateGroupCheckbox();
                    }
                });
            } else {

                scope.$watch('data', function (newValue) {
                    if (scope.settings.get('expandAllRows')) {
                        expandAllRows();
                    }
                    scope.visibleData = scope.data;
                    mstarComponent.getComponentInstance().setModelProperty('visibleRows', scope.data);
                    scope.selectAll = false;
                    if (scope.settings.get('enablePartialCheckbox')) {
                        updateGroupCheckbox();
                    }
                }, true);
            }

            function updateGroupCheckbox() {
                scope.selectAll = false;

                // Check that there is visible data
                if (scope.visibleData) {
                    var selectedItemKeys = scope.instance.getParameter('selectedItemKeys'),
                        visibleDataSelectedItems = scope.visibleData.filter(function (currentRow) {
                        return selectedItemKeys.indexOf(scope.keyFieldParsed(currentRow)) !== -1;
                    });

                    if (visibleDataSelectedItems.length && visibleDataSelectedItems.length < scope.visibleData.length) {
                        scope.mixedSelect = true;
                    } else {
                        scope.mixedSelect = false;
                        if (scope.visibleData.length && visibleDataSelectedItems.length === scope.visibleData.length) {
                            scope.selectAll = true;
                        }
                    }
                }
            }

            var updateVisibleFootNotes = function updateVisibleFootNotes(newValue) {
                if (angular.isUndefined(newValue)) {
                    return;
                }

                if (!angular.isArray(newValue)) {
                    return;
                }

                //add the filter to map the note to field
                var footNotes = [];
                _.each(newValue, function (footNote, i) {
                    var visibleField = _.find(scope.visibleFields, function (field) {
                        return field.fieldName === footNote.fieldName;
                    });
                    if (visibleField) {
                        footNotes.push(footNote);
                    }
                });

                scope.footNotes = footNotes;
            };

            scope.$watchCollection('footNotes', function (newValue) {
                updateVisibleFootNotes(newValue);
            }, true);

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:rows', function (newValue) {
                scope.$evalAsync(function () {
                    scope.data = scope.model.rows;
                    stickyHandleNewSizeInDimensions();
                });
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:footNotes', function (newValue) {
                scope.$evalAsync(function () {
                    updateVisibleFootNotes(scope.model.footNotes);
                });
            }));

            scope.toggleSelectedRows = function (event) {
                var visibleKeys = [];
                scope.selectAll = !scope.selectAll;

                _.each(scope.visibleData, function (item) {
                    var key = scope.keyFieldParsed(item);
                    visibleKeys.push(key);
                    toggleSelect(key, scope.selectAll);
                });

                // Remove partial select class
                if (scope.settings.get('enablePartialCheckbox')) {
                    scope.mixedSelect = false;
                }
                // Trigger listener for select all.
                scope.instance.trigger('click', [event, 'toggleAllSelection', scope.selectAll, visibleKeys, scope.visibleData]);
            };

            scope.toggleSelectedRow = function (key, obj, $event, field) {
                var rowClicked = $event.currentTarget.tagName.toLowerCase() === 'tr';
                if (rowClicked && (!scope.settings.get('selectByRowEnabled') || !key)) {
                    return;
                }

                if (!field) {
                    //loop fields to find the radio fieldSetting
                    field = _.find(scope.visibleFields, function (visibleField) {
                        return visibleField.fieldSettings.itemTemplate === 'radio';
                    });
                }

                toggleSelect(key, null, field);
                $event.stopPropagation();

                // Trigger listener for single selection.
                scope.instance.trigger('click', [$event, 'toggleSingleSelection', scope.isSelected(key), key, obj]);

                if (scope.settings.get('enablePartialCheckbox')) {
                    updateGroupCheckbox();
                }
                scope.instance.trigger('ecTableRowSelected', [obj]);
            };

            scope.isSelected = function (key) {
                return scope.parameters.selectedItemKeys && scope.parameters.selectedItemKeys.length > 0 && scope.parameters.selectedItemKeys.indexOf(key) > -1;
            };

            scope.parameters.deselectAll = function () {
                scope.parameters.selectedItemKeys = [];
            };

            function toggleSelect(key, add, field) {
                if (typeof add === 'boolean') {
                    if (add) {
                        selectItem(key);
                    } else {
                        deselectItem(key);
                    }
                } else {
                    if (field && field.fieldSettings.itemTemplate === 'radio') {
                        scope.parameters.selectedItemKeys = [];
                        scope.parameters.selectedItemKeys.push(key);
                    } else {
                        if (scope.isSelected(key)) {
                            deselectItem(key);
                        } else {
                            selectItem(key);
                        }
                    }
                }
            }

            function selectItem(key) {
                if (!scope.isSelected(key)) {
                    scope.parameters.selectedItemKeys.push(key);
                }
            }

            function deselectItem(key) {
                if (scope.isSelected(key)) {
                    scope.parameters.selectedItemKeys.splice(scope.parameters.selectedItemKeys.indexOf(key), 1);
                }
            }

            if (scope.settings.get('accordionMode')) {
                scope.accordionShowMoreLessText = scope.labels.get('accordionShowMore');
            }

            var showExpandedRows = false;

            scope.handleTableRowsToggle = function (event) {
                if (showExpandedRows) {
                    showLessRows(this);
                    showExpandedRows = false;
                    scope.instance.trigger('ecTableShowLessRows', [event]);
                } else {
                    showMoreRows(this);
                    showExpandedRows = true;
                    scope.instance.trigger('ecTableShowMoreRows', [event]);
                }
            };

            function showMoreRows(toggleButton) {
                elem.addClass('ec-table--show-all');
                swapTextButton(toggleButton, scope.labels.get('accordionShowLess'));
            }

            function showLessRows(toggleButton) {
                elem.removeClass('ec-table--show-all');
                swapTextButton(toggleButton, scope.labels.get('accordionShowMore'));
            }

            function swapTextButton(toggleButton, toggleButtonText) {
                toggleButton.accordionShowMoreLessText = toggleButtonText;
            }

            // Details accordion (expand "columns" in mobile)

            scope.handleTableDetailsToggle = function (event) {
                if ($(event.currentTarget).parents('.ec-table__row').hasClass('ec-table__row--details-show')) {
                    lessTableDetails(event);
                } else {
                    moreTableDetails(event);
                }
            };

            if (scope.settings.get('accordionDetailsEnable')) {
                scope.accordionDetailsButton = scope.labels.get('accordionDetailsShow');

                mstarDimensions(scope, elem).addListener(function (dimensions) {
                    if (dimensions.width < scope.settings.get('accordionDetailsComponentMaxWidth')) {
                        elem.find('.ec-table__cell--showdetails').show();
                    } else {
                        elem.find('.ec-table__cell--showdetails').hide();
                    }
                });
            }

            function moreTableDetails(toggleButton) {
                $(toggleButton.currentTarget).parents('.ec-table__row').addClass('ec-table__row--details-show');
                swapDetailsTextButton(toggleButton, scope.labels.get('accordionDetailsHide'));
            }

            function lessTableDetails(toggleButton) {
                $(toggleButton.currentTarget).parents('.ec-table__row').removeClass('ec-table__row--details-show');
                swapDetailsTextButton(toggleButton, scope.labels.get('accordionDetailsShow'));
            }

            function swapDetailsTextButton(toggleButton, toggleButtonText) {
                $(toggleButton.currentTarget).text(toggleButtonText);
            }

            scope.showMoreLink = function () {
                if (scope.settings.get('accordionMode')) {
                    if (scope.settings.get('orientation') === 'vertical') {
                        return scope.model.rows && scope.model.rows.length > scope.settings.get('accordionMinRow');
                    } else {
                        return scope.settings.get('fields').length > scope.settings.get('accordionMinRow');
                    }
                }
            };

            // POST client_profile merge fix: Since the '__cell--out-of-range' flag will be added to all table cells, so the table cells will be hidden at launch (INTL-16096)
            // This function fixes the hidden data-point issues after all datapoint cells added with '__cell--out-of-range'(line 13, cell.js)
            function fixStickyStatus() {
                if (scope.settings.get('stickyLeadEnabled')) {
                    stickyHandleNewSize(mstarDimensions(scope, elem).getDimensions());
                }
            }

            function populateSortDropdown(fieldsArray) {
                var sortedHeaders = [];
                _.each(fieldsArray, function (fieldObj) {
                    if (fieldObj.sortingEnabled) {
                        sortedHeaders.push(fieldObj);
                    }
                });
                scope.instance.setParameter('sortableFields', sortedHeaders);
            }

            function getDragDropIndex(fields, srcField, destField, direction) {
                var srcIndex = _.findIndex(fields, {
                    fieldName: srcField.fieldName
                }),
                    destIndex = _.findIndex(fields, {
                    fieldName: destField.fieldName
                });
                if (srcIndex < destIndex) {
                    destIndex = direction === 'left' || direction === 'top' ? destIndex - 1 : destIndex;
                } else if (srcIndex > destIndex) {
                    destIndex = direction === 'right' || direction === 'bottom' ? destIndex + 1 : destIndex;
                }
                return {
                    src: srcIndex,
                    dest: destIndex
                };
            }

            function swapFields(fields, srcField, destField, direction) {
                var newFields = fields.slice(),
                    idx = getDragDropIndex(fields, srcField, destField, direction);
                if (idx.dest !== idx.src) {
                    newFields.splice(idx.dest, 0, newFields.splice(idx.src, 1)[0]);
                }
                return newFields;
            }

            mstarComponent.addUnregisterCallback(scope.instance.on('dragStart', function (proxy) {
                var drag = proxy.drag();
                if (drag.element.hasClass(scope.namespaceClass('__cell'))) {
                    //draging column
                    if (scope.settings.get('orientation') === 'vertical') {
                        proxy.direction('x').containment(drag.element.parent());
                    } else {
                        var bounds = drag.element[0].getBoundingClientRect(),
                            elemParent = drag.element.parent().parent(),
                            parentOffset = elemParent.offset();
                        proxy.direction('y').containment({
                            left: bounds.left,
                            right: bounds.right,
                            top: parentOffset.top,
                            bottom: elemParent.outerHeight(true) + parentOffset.top
                        });
                    }
                    proxy.element().html(drag.scope.field.header);
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('drag', function (proxy) {
                var drop = proxy.drop();
                if (!drop) {
                    return;
                }
                var dropElem = drop.element;
                if (dropElem.hasClass(scope.namespaceClass('__cell'))) {
                    //means draging in a dropable element
                    if (scope.settings.get('orientation') === 'vertical') {
                        dropElem.removeClass(scope.namespaceClass('__cell--highlight-left') + ' ' + scope.namespaceClass('__cell--highlight-right')).addClass(scope.namespaceClass('__cell--highlight-' + drop.areaPos[0]));
                    } else {
                        dropElem.removeClass(scope.namespaceClass('__cell--highlight-top') + ' ' + scope.namespaceClass('__cell--highlight-bottom')).addClass(scope.namespaceClass('__cell--highlight-' + drop.areaPos[1]));
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('drop', function (proxy) {
                var dropElem = proxy.drop().element;
                if (dropElem.hasClass(scope.namespaceClass('__cell'))) {
                    var dragField = proxy.drag().scope.field,
                        dropField = proxy.drop().scope.field;
                    if (dropField.fieldName !== dragField.fieldName) {
                        scope.parameters.fields = swapFields(scope.parameters.fields, dragField, dropField, proxy.drop().areaPos[scope.settings.get('orientation') === 'vertical' ? 0 : 1]);
                        scope.$apply(function () {
                            handleFields(scope.parameters.fields);
                        });
                    }
                    if (scope.settings.get('orientation') === 'vertical') {
                        dropElem.removeClass(scope.namespaceClass('__cell--highlight-left')).removeClass(scope.namespaceClass('__cell--highlight-right'));
                    } else {
                        dropElem.removeClass(scope.namespaceClass('__cell--highlight-top')).removeClass(scope.namespaceClass('__cell--highlight-bottom'));
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('dropOut', function (proxy) {
                var dropElem = proxy.drop().element;
                if (dropElem.hasClass(scope.namespaceClass('__cell'))) {
                    if (scope.settings.get('orientation') === 'vertical') {
                        dropElem.removeClass(scope.namespaceClass('__cell--highlight-left')).removeClass(scope.namespaceClass('__cell--highlight-right'));
                    } else {
                        dropElem.removeClass(scope.namespaceClass('__cell--highlight-top')).removeClass(scope.namespaceClass('__cell--highlight-bottom'));
                    }
                }
            }));

            function expandAllRows() {
                var expandAllRows = scope.settings.get('expandAllRows');
                _.each(scope.data, function (obj) {
                    if (_.isUndefined(obj._displayingExpandedView)) {
                        obj._displayingExpandedView = expandAllRows;
                    }
                });
            }
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {
	"ecTable": {
		"components": {
			"paginator": {
				"settings": {
					"_parameters": {
						"page": {
							"binding": "{{_ parameters(_).page _}}"
						},
						"paginationWindowSize": {
							"binding": "{{_ parameters(_).paginationWindowSize _}}"
						},
						"perPage": {
							"binding": "{{_ parameters(_).perPage _}}"
						},
						"totalRows": {
							"binding": "{{_ parameters(_).totalRows _}}"
						}
					},
					"numberOfWrappingPageLinks": 1
				},
				"type": "ecPaginator"
			},
			"paginatorSticky": {
				"labels": {
					"next": {
						"da-DK": "Næste søjler",
						"en": "Next columns",
						"fr": "Suivant",
						"fr-CA": "Colonnes suivantes",
						"it": "Colonne successive",
						"ja": "次の列",
						"sv": "Följande kolumner",
						"zh-CN": "下列",
						"zh-HK": "下列"
					},
					"previous": {
						"da-DK": "Forrige søjler",
						"en": "Previous columns",
						"fr": "Précédent",
						"fr-CA": "Colonnes précédentes",
						"it": "Colonne precedenti",
						"ja": "前の列",
						"sv": "Föregående kolumner",
						"zh-CN": "前列",
						"zh-HK": "前列"
					}
				},
				"settings": {
					"_parameters": {
						"page": {
							"binding": "{{_ parameters(_).stickyState.currentPage _}}"
						},
						"paginationWindowSize": {
							"binding": "{{_ parameters(_).paginationWindowSize _}}"
						},
						"perPage": {
							"binding": "{{_ parameters(_).stickyState.columnsPerPage _}}"
						},
						"totalRows": {
							"binding": "{{_ parameters(_).stickyState.totalNonStickyColumns _}}"
						}
					},
					"showPageNumbers": false
				},
				"type": "ecPaginator"
			},
			"paginatorTop": {
				"settings": {
					"_parameters": {
						"page": {
							"binding": "{{_ parameters(_).page _}}"
						},
						"paginationWindowSize": {
							"binding": "{{_ parameters(_).paginationWindowSize _}}"
						},
						"perPage": {
							"binding": "{{_ parameters(_).perPage _}}"
						},
						"totalRows": {
							"binding": "{{_ parameters(_).totalRows _}}"
						}
					},
					"numberOfWrappingPageLinks": 1
				},
				"type": "ecPaginator"
			},
			"sortFieldsDropdown": {
				"labels": {
					"placeholderTextSingle": {
						"da-DK": "Vælg sorteringskriterie..",
						"en": "Select sorting field..",
						"fr": "Sélectionner le champ de tri",
						"it": "Seleziona campo di ordinamento…",
						"ja": "並び替え項目を選択",
						"sv": "Välj sorteringsfält",
						"zh-CN": "选择排序项",
						"zh-HK": "選擇排序項"
					}
				},
				"settings": {
					"_model": {
						"listItems": {
							"dataSourceType": "selector",
							"evaluationTypes": {
								"parameters": true
							},
							"selector": "{{_ parameters(_).sortableFields _}}"
						}
					},
					"allowSingleDeselect": false,
					"disableSearch": true,
					"keyField": "fieldName",
					"multiple": false,
					"valueField": "header"
				},
				"type": "ecChosen"
			},
			"sortOrderRadio": {
				"labels": {
					"placeholderTextSingle": {
						"da-DK": "Vælg en sorteringsrækkefølge...",
						"en": "Select a sorting order..",
						"fr": "Sélectionner l'ordre de tri",
						"fr-CA": "Sélectionnez l'ordre de tri",
						"it": "Seleziona tipo di ordinamento…",
						"ja": "並び替え順を選択",
						"sv": "Välj sorteringsordning",
						"zh-CN": "选择顺序",
						"zh-HK": "選擇順序"
					}
				},
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "asc",
								"value": "asc"
							},
							{
								"key": "desc",
								"value": "desc"
							}
						]
					},
					"allowSingleDeselect": false,
					"controlType": "radio",
					"disableSearch": true,
					"keyField": "key",
					"multiple": false
				},
				"type": "ecChosen"
			}
		},
		"labels": {
			"accordionDetailsHide": {
				"da-DK": "Skjul detaljerede oplysninger",
				"en": "Hide full details",
				"fr": "Cacher les détails complets",
				"fr-CA": "Cacher tous les détails",
				"it": "Nascondi tutti i dettagli",
				"ja": "詳細を非表示",
				"sv": "Dölja detaljer",
				"zh-CN": "隐藏全部详情",
				"zh-HK": "隱藏全部詳情"
			},
			"accordionDetailsShow": {
				"da-DK": "Vis detaljerede oplysninger",
				"en": "Show full details",
				"fr": "Afficher les détails complets",
				"fr-CA": "Afficher tous les détails",
				"it": "Mostra tutti i dettagli",
				"ja": "詳細を表示",
				"sv": "Visa detaljer",
				"zh-CN": "显示全部详情",
				"zh-HK": "顯示全部詳情"
			},
			"accordionShowLess": {
				"da-DK": "Vis mindre",
				"en": "Show less",
				"fr": "Afficher moins",
				"it": "Mostra meno",
				"ja": "閉じる",
				"sv": "Visa mindre",
				"zh-CN": "显示较少",
				"zh-HK": "顯示較少"
			},
			"accordionShowMore": {
				"da-DK": "Vis mere",
				"en": "Show more",
				"es": "Mostrar más",
				"fr": "Afficher plus",
				"fr-CA": "Afficher Plus",
				"it": "Mostra di più",
				"ja": "さらに表示",
				"sv": "Visa mer",
				"zh-CN": "显示更多",
				"zh-HK": "顯示更多"
			},
			"asc": {
				"da-DK": "Lavest til højest",
				"en": "Asc",
				"fr": "Croissant",
				"it": "Asc",
				"ja": "昇順",
				"sv": "Stigande",
				"zh-CN": "顺序",
				"zh-HK": "順序"
			},
			"desc": {
				"da-DK": "Højest til Lavest",
				"en": "Desc",
				"fr": "Décroissant",
				"it": "Disc",
				"ja": "降順",
				"sv": "Fallande",
				"zh-CN": "倒序",
				"zh-HK": "倒序"
			},
			"sortBy": {
				"da-DK": "Vælg sorteringsrækkefølge:",
				"en": "Select sort order:",
				"en-GB": null,
				"fr": "Sélectionner le champ de tri",
				"fr-CA": "Sélectionnez l'ordre de tri",
				"it": "Seleziona ordine:",
				"ja": "並び替え順を選択",
				"sv": "Välj sorteringsordning",
				"sv-SE": null,
				"zh-CN": "选择顺序",
				"zh-HK": "選擇順序"
			},
			"sortField": {
				"da-DK": "Vælg sorteringsparameter:",
				"en": "Select sort field:",
				"en-GB": null,
				"fr": "Sélectionner l'ordre de tri",
				"fr-CA": "Sélectionnez le champ de tri",
				"it": "Seleziona campo di ordinamento:",
				"ja": "並び替え項目を選択",
				"sv": "Välj fält att sortera på",
				"sv-SE": null,
				"zh-CN": "选择排序项",
				"zh-HK": "選擇排序項"
			}
		},
		"settings": {
			"_model": null,
			"_parameters": {
				"caption": null,
				"defaultPage": {},
				"fields": null,
				"keyField": null,
				"page": null,
				"paginationWindowSize": {},
				"perPage": null,
				"selectedItemKeys": null,
				"sortField": null,
				"sortFunc": {},
				"sortOrder": null,
				"sortableFields": {},
				"stickyLeadBreakPoints": null,
				"stickyState": null,
				"totalRows": null
			},
			"_templates": {
				"expandedRow": null,
				"footNoteItemTemplate": "﻿<span class=\"ec-table__foot-note-indicator\">{{labels.get(footNote.indicatorLabelKey) }}:</span>\r\n<span class=\"ec-table__foot-note-content\" data-ng-bind-html=\"footNote.content\"></span>\r\n",
				"light": "<ec-section template-type=\"light\">\r\n    <table class=\"ec-table__table ec-table__table--{{ :: settings.get('stickyLeadEnabled') ? 'sticky' : (settings.get('orientation') === 'vertical' ? 'vertical' : 'horizontal') }}{{ :: settings.get('stickyLeadEnabled') || settings.get('responsiveEnabled') ? '' : '-non-responsive' }}\">\r\n\r\n        <caption class=\"{{ settings.get('hideCaption') || !settings.get('caption') ? 'ec-table__caption--hidden' : 'ec-table__caption' }}\" mstar-tooltip-content=\"{{ :: labels.contains(settings.get('caption') + 'Tooltip') ? labels.get(settings.get('caption') + 'Tooltip') : '' }}\" mstar-tooltip>\r\n            {{ settings.get('caption') ? labels.get(settings.get('caption')) : namespaceId() }}\r\n        </caption>\r\n\r\n        <thead data-ng-if=\"settings.get('orientation') === 'vertical'\" class=\"ec-table__thead ec-table__thead--vertical{{ :: settings.get('responsiveEnabled') ? '' : '-non-responsive' }}\">\r\n            <tr class=\"ec-table__row-header\">\r\n                <th scope=\"col\" ec-table-cell data-ng-repeat=\"field in visibleFields track by field.fieldName\" data-ng-class=\"{ 'ec-table__cell--numeric': field.formatDataType == 'number'}\" class=\"ec-table__cell ec-table__cell--header\">\r\n                    <span mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>{{ ::field.header }}</span>\r\n                </th>\r\n            </tr>\r\n        </thead>\r\n\r\n        <tbody data-ng-if=\"settings.get('orientation') === 'vertical'\" class=\"ec-table__tbody ec-table__tbody--vertical{{ :: settings.get('responsiveEnabled') ? '' : '-non-responsive' }}\">\r\n            <tr data-ng-repeat=\"obj in visibleData track by keyFieldParsed(obj) || $index\" class=\"ec-table__row\">\r\n                <td ec-table-cell-light data-ng-repeat=\"field in visibleFields track by field.fieldId || field.fieldName\"\r\n                    data-title=\"{{ ::field.header }}\" class=\"ec-table__cell ec-table__cell--data {{ :: field.formatDataType === 'number' ? 'ec-table__cell--numeric' : '' }}\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        {{ field.format(field.getter(obj)) }}\r\n                    </div>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n\r\n        <tbody data-ng-if=\"settings.get('orientation') === 'horizontal'\" class=\"ec-table__tbody ec-table__tbody--horizontal\">\r\n            <tr data-ng-repeat=\"field in visibleFields track by field.fieldId || field.fieldName\" class=\"ec-table__row\">\r\n                <th scope=\"row\" ec-table-cell-light data-ng-if=\"!field.fieldSettings.headerSkipped\"\r\n                    class=\"ec-table__cell ec-table__cell--header\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        <span mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>\r\n                            {{ ::field.header }}\r\n                        </span>\r\n                    </div>\r\n                </th>\r\n                <td ec-table-cell-light data-ng-repeat=\"obj in visibleData track by keyFieldParsed(obj) || $index\"\r\n                    data-title=\"{{ ::field.header }}\" class=\"ec-table__cell ec-table__cell--data {{ :: field.formatDataType === 'number' ? 'ec-table__cell--numeric' : '' }}\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        {{ field.format(field.getter(obj)) }}\r\n                    </div>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n\r\n    </table>\r\n    <footer data-ng-if=\"footNotes\" class=\"ec-table__footer\">\r\n        <ul class=\"ec-table__foot-notes\">\r\n            <li data-ng-repeat=\"footNote in footNotes\" class=\"ec-table__foot-note\">\r\n                <ec-table-foot-note></ec-table-foot-note>\r\n            </li>\r\n        </ul>\r\n    </footer>\r\n</ec-section>\r\n",
				"main": "<ec-section>\r\n\r\n    <ec-paginator mstar-component-id=\"paginatorTop\" data-ng-if=\"settings.get('paginationMode') == 'top' || settings.get('paginationMode') == 'both'\"></ec-paginator>\r\n\r\n    <ec-paginator mstar-component-id=\"paginatorSticky\" data-ng-class=\"settings.get('columnSkipActionsClass')\"\r\n        data-ng-if=\"settings.get('stickyLeadEnabled') && parameters.stickyState.stickyMode && settings.get('stickyPaginationMode') === 'top'\">\r\n    </ec-paginator>\r\n\r\n    <div mstar-include=\"templates.sortControls\" data-ng-if=\"settings.get('sortingEnabled')\"></div>\r\n    <table role=\"grid\" mstar-loader=\"model.rows._$isLoading\" data-ng-class=\":: settings.get('stickyLeadEnabled') ? 'ec-table__table--sticky' : ((settings.get('orientation') === 'vertical' ? 'ec-table__table--vertical' : 'ec-table__table--horizontal') + (settings.get('responsiveEnabled')?'':'-non-responsive'))\"\r\n        data-ng-swipe-disable-mouse data-ng-swipe-left=\"swipeLeft()\" data-ng-swipe-right=\"swipeRight()\" class=\"ec-table__table\">\r\n\r\n        <caption class=\"{{ settings.get('hideCaption') || !settings.get('caption') ? 'ec-table__caption--hidden' : 'ec-table__caption' }}\" mstar-tooltip-content=\"{{ :: labels.contains(settings.get('caption') + 'Tooltip') ? labels.get(settings.get('caption') + 'Tooltip') : '' }}\" mstar-tooltip>\r\n            {{ settings.get('caption') ? labels.get(settings.get('caption')) : namespaceId() }}\r\n        </caption>\r\n\r\n        <thead data-ng-if=\"settings.get('orientation') === 'vertical'\" class=\"ec-table__thead  ec-table__thead--vertical{{ :: settings.get('responsiveEnabled')?'':'-non-responsive' }}\">\r\n            <tr class=\"ec-table__row-header\">\r\n                <th data-ng-if=\"!field.fieldSettings.headerSkipped\" scope=\"col\" ec-table-cell data-ng-click=\"field.sortingEnabled && sort(field.fieldName)\" data-ng-repeat=\"field in visibleFields track by field.fieldName\" data-ng-class=\"{ 'ec-table__cell--numeric': field.formatDataType == 'number',\r\n                    'ec-table__cell--header-sorted': field.sortingEnabled && field.fieldName === parameters.sortField }\" class=\"ec-table__cell ec-table__cell--header\" mstar-drag=\"{{field.rearrangeEnabled && settings.get('columnsRearrangeEnabled') ? namespaceId() : ''}}\"\r\n                    mstar-drop=\"{{field.rearrangeEnabled && settings.get('columnsRearrangeEnabled') ? namespaceId() : ''}}\">\r\n                    <a href=\"javascript:;\" data-ng-if=\"field.sortingEnabled\" class=\"ec-table__sort\">\r\n                        <span mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>{{ ::field.header }}</span>\r\n                        <i class=\"fa fa-fw fa-sort\" data-ng-if=\"field.fieldName !== parameters.sortField\"></i>\r\n                        <i class=\"fa fa-fw fa-sort-{{parameters.sortOrder}}\" data-ng-if=\"field.fieldName === parameters.sortField\"></i>\r\n                    </a>\r\n                    <span data-ng-if=\"!field.sortingEnabled\" mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>{{ ::field.header }}</span>\r\n                </th>\r\n            </tr>\r\n        </thead>\r\n\r\n        <tbody data-ng-if=\"settings.get('orientation') === 'vertical'\" class=\"ec-table__tbody ec-table__tbody--vertical{{ :: settings.get('responsiveEnabled')?'':'-non-responsive' }}\">\r\n            <tr data-ng-repeat-start=\"obj in visibleData track by keyFieldParsed(obj) || $index\" data-ng-class=\"[isSelected(keyFieldParsed(obj)) ? 'ec-table__row--selected' : '', (templates.expandedRow && obj._displayingExpandedView) ? 'ec-table__row--expanded' : '', settings.get('selectByRowEnabled') ? 'ec-table__row--clickable' : '', (settings.get('accordionMode') && $index > settings.get('accordionMinRow') - 1) ? 'ec-table__row--hide' : '']\"\r\n                data-ng-click=\"toggleSelectedRow(keyFieldParsed(obj), obj, $event)\" data-ng-init=\"rowIndex=$index\" class=\"ec-table__row\" id=\"{{namespaceId('-row-'+$index)}}\">\r\n                <td ec-table-cell data-ng-repeat=\"field in visibleFields track by field.fieldId || field.fieldName\" data-ng-class=\"[(settings.get('accordionDetailsEnable') && $index > settings.get('accordionDetailsMinRow') - 1) ? 'ec-table__cell--details-hide' : '', field.formatDataType == 'number' ? 'ec-table__cell--numeric' : '']\"\r\n                    data-ng-init=\"colIndex=$index\" data-title=\"{{ ::field.header }}\" class=\"ec-table__cell ec-table__cell--data\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        {{ field.format(field.getter(obj)) }}\r\n                    </div>\r\n                </td>\r\n                <td class=\"ec-table__cell--showdetails\" data-ng-if=\"settings.get('accordionDetailsEnable')\">\r\n                    <button data-ng-click=\"handleTableDetailsToggle($event)\" data-ng-class=\"tableDetailsToggleClass\" class=\"ec-table__toggle-details\">{{accordionDetailsButton}}</button>\r\n                </td>\r\n            </tr>\r\n            <tr data-ng-repeat-end data-ng-if=\"templates.expandedRow && obj._displayingExpandedView\" class=\"ec-table__row ec-table__row--extended\">\r\n                <td colspan=\"{{ visibleFields.length }}\" class=\"ec-table__cell ec-table__cell--data ec-table__cell--last\">\r\n                    <div mstar-include=\"templates.expandedRow\"></div>\r\n                </td>\r\n                <td class=\"ec-table__cell--showdetails\" data-ng-if=\"settings.get('accordionDetailsEnable')\"></td>\r\n            </tr>\r\n        </tbody>\r\n\r\n        <tbody data-ng-if=\"settings.get('orientation') === 'horizontal'\" class=\"ec-table__tbody ec-table__tbody--horizontal\">\r\n            <tr class=\"ec-table__row-header\" data-ng-if=\"settings.get('horizontalHeaderField')\">\r\n                <td data-ng-if=\"!labels.contains(settings.get('horizontalHeaderField'))\"></td>\r\n                <th scope=\"col\" data-ng-if=\"labels.contains(settings.get('horizontalHeaderField'))\" class=\"ec-table__cell ec-table__cell--header\">{{labels.get(settings.get('horizontalHeaderField'))}}</th>\r\n                <th scope=\"col\" data-ng-repeat=\"obj in visibleData track by keyFieldParsed(obj) || $index\" class=\"ec-table__cell ec-table__cell--header\">\r\n                    {{ obj[settings.get('horizontalHeaderField')] }}\r\n                </th>\r\n            </tr>\r\n            <tr data-ng-class=\"(settings.get('accordionMode') && $index > settings.get('accordionMinRow') - 1) ? 'ec-table__row--hide' : ''\" data-ng-repeat=\"field in visibleFields track by field.fieldId || field.fieldName\" data-ng-init=\"rowIndex=$index\" class=\"ec-table__row\">\r\n                <th scope=\"row\" ec-table-cell data-ng-click=\"field.sortingEnabled && sort(field.fieldName)\" data-col-index=\"0\" data-ng-if=\"!field.fieldSettings.headerSkipped\" data-ng-class=\"{ 'ec-table__cell--header-sorted': field.sortingEnabled && field.fieldName === parameters.sortField }\"\r\n                    class=\"ec-table__cell ec-table__cell--header\" mstar-drag=\"{{field.rearrangeEnabled && settings.get('columnsRearrangeEnabled') ? namespaceId() : ''}}\" mstar-drop=\"{{field.rearrangeEnabled && settings.get('columnsRearrangeEnabled') ? namespaceId() : ''}}\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        <a data-ng-if=\"field.sortingEnabled\" href=\"javascript:;\" class=\"ec-table__sort\">\r\n                            <span mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>{{ ::field.header }}</span>\r\n                            <i class=\"fa fa-fw fa-sort\" data-ng-if=\"field.fieldName !== parameters.sortField\"></i>\r\n                            <i class=\"fa fa-fw fa-sort-{{parameters.sortOrder}}\" data-ng-if=\"field.fieldName === parameters.sortField\"></i>\r\n                        </a>\r\n                        <span data-ng-if=\"!field.sortingEnabled\" mstar-tooltip-content=\"{{ :: labels.contains(field.headerLabelKey + 'Tooltip') ? labels.get(field.headerLabelKey + 'Tooltip') : '' }}\" mstar-tooltip>\r\n                            {{ ::field.header }}\r\n                        </span>\r\n                    </div>\r\n                </th>\r\n                <td ec-table-cell data-ng-class=\"[isSelected(keyFieldParsed(obj)) ? 'ec-table__row--selected' : '', field.formatDataType == 'number' ? 'ec-table__cell--numeric' : '']\" data-ng-repeat=\"obj in visibleData track by keyFieldParsed(obj) || $index\"\r\n                    data-ng-init=\"colIndex=$index\" data-title=\"{{ ::field.header }}\" class=\"ec-table__cell ec-table__cell--data\">\r\n                    <div class=\"ec-table__cell-content\">\r\n                        {{ field.format(field.getter(obj)) }}\r\n                    </div>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n\r\n    </table>\r\n\r\n    <footer data-ng-if=\"footNotes\" class=\"ec-table__footer\">\r\n        <ul class=\"ec-table__foot-notes\">\r\n            <li data-ng-repeat=\"footNote in footNotes\" class=\"ec-table__foot-note\">\r\n                <ec-table-foot-note></ec-table-foot-note>\r\n            </li>\r\n        </ul>\r\n    </footer>\r\n\r\n    <button data-ng-if=\"settings.get('accordionMode') && showMoreLink()\" data-ng-click=\"handleTableRowsToggle($event)\" data-ng-class=\"tableRowsToggleClass\" class=\"ec-table__toggle-row\">\r\n        {{accordionShowMoreLessText}}\r\n    </button>\r\n\r\n    <ec-paginator mstar-component-id=\"paginator\" data-ng-if=\"settings.get('paginationMode') == 'bottom' || settings.get('paginationMode') == 'both'\"></ec-paginator>\r\n\r\n    <ec-paginator mstar-component-id=\"paginatorSticky\" data-ng-class=\"settings.get('columnSkipActionsClass')\"\r\n        data-ng-if=\"settings.get('stickyLeadEnabled') && parameters.stickyState.stickyMode && settings.get('stickyPaginationMode') === 'bottom'\">\r\n    </ec-paginator>\r\n\r\n</ec-section>\r\n",
				"sortControls": "<div class=\"ec-table__sort-controls\">\r\n\t<div class=\"ec-table__sort-options\">\r\n    \t<label class=\"ec-table__sort-field\">{{labels.get(\"sortField\")}}</label>\r\n        <ec-chosen mstar-component-id=\"sortFieldsDropdown\" data-ng-model=\"parameters.sortField\"></ec-chosen>\r\n    </div>\r\n    <div class=\"ec-table__sort-order\">\r\n    \t<label class=\"ec-table__sort-label\">{{labels.get(\"sortBy\")}}</label>\r\n    \t<ec-chosen mstar-component-id=\"sortOrderRadio\" data-ng-model=\"parameters.sortOrder\"></ec-chosen>\r\n    </div>\r\n</div>\r\n"
			},
			"accordionDetailsComponentMaxWidth": 668,
			"accordionDetailsEnable": false,
			"accordionDetailsHide": "Hide full details",
			"accordionDetailsMinRow": 3,
			"accordionDetailsShow": "Show full details",
			"accordionMinRow": 5,
			"accordionMode": false,
			"caption": null,
			"columnSkipActionsClass": null,
			"columnsRearrangeEnabled": false,
			"defaultFieldSettings": {
				"button": {
					"click": null,
					"componentId": null
				},
				"buttonItemTemplate": "<td>\r\n    <div class=\"{{namespaceClass('__cell-content')}}\">\r\n        <ec-button mstar-component-id=\"{{settings.get('orientation') === 'horizontal' ? field.fieldSettings.button.componentId + '[' + colIndex + ']' : field.fieldSettings.button.componentId + '[' + rowIndex + ']'}}\" data-ng-click=\"field.fieldSettings.button.click(keyFieldParsed(obj), $event)\"></ec-button>\r\n    </div>\r\n</td>\r\n",
				"checkboxHeaderTemplate": "<th>\r\n    <div class=\"{{namespaceClass('__cell-content')}}\">\r\n        <div class=\"ec-form__checkbox\" data-ng-class=\"{'ec-form__checkbox--mixed' : mixedSelect && settings.get('enablePartialCheckbox')}\">\r\n            <label class=\"ec-form__label ec-form__label--checkbox\">\r\n                <!-- TODO: ecChosen's checkbox? -->\r\n                <input type=\"checkbox\" data-ng-checked=\"selectAll\" class=\"{{namespaceClass('__checkbox')}}\" data-ng-click=\"toggleSelectedRows($event)\" />\r\n                <span class=\"ec-form__checkbox-text\">\r\n                    <!-- TODO: Add label -->\r\n                </span>\r\n            </label>\r\n        </div>\r\n    </div>\r\n</th>\r\n",
				"checkboxItemTemplate": "<td>\r\n    <div class=\"{{namespaceClass('__cell-content')}} {{namespaceClass('__cell--checkbox')}}\">\r\n        <div class=\"ec-form__checkbox\">\r\n            <label class=\"ec-form__label ec-form__label--checkbox\">\r\n                <!-- TODO: ecChosen's checkbox? -->\r\n                <input type=\"checkbox\" data-ng-checked=\"isSelected(keyFieldParsed(obj))\" data-ng-click=\"toggleSelectedRow(keyFieldParsed(obj), obj, $event, field)\" class=\"{{namespaceClass('__checkbox')}}\" />\r\n                <span class=\"ec-form__checkbox-text\">\r\n                    <!-- TODO: Add label -->\r\n                </span>\r\n            </label>\r\n        </div>\r\n\r\n    </div>\r\n</td>\r\n",
				"headerColspan": -1,
				"headerRowspan": -1,
				"headerSkipped": false,
				"headerTemplate": null,
				"hyperlink": {
					"cssClass": null,
					"target": null,
					"text": null,
					"textField": null,
					"url": null,
					"urlFields": null
				},
				"hyperlinkItemTemplate": "<td>\r\n    <div class=\"{{namespaceClass('__cell-content')}}\">\r\n        <a data-ng-href=\"{{getHyperlinkUrl(obj, field.fieldSettings.hyperlink)}}\"\r\n           data-ng-attr-target=\"{{field.fieldSettings.hyperlink.target || undefined}}\"\r\n           data-ng-class=\"field.fieldSettings.hyperlink.cssClass\"\r\n           data-ng-click=\"openHyperlink($event);\"\r\n           class=\"{{namespaceClass('__link')}}\">{{getHyperlinkText(obj, field.fieldSettings.hyperlink)}}</a>\r\n    </div>\r\n</td>\r\n",
				"itemTemplate": null,
				"radioItemTemplate": "<td>\r\n    <div class=\"{{namespaceClass('__cell-content')}} {{namespaceClass('__cell--radio')}}\" data-ng-class=\"isSelected(keyFieldParsed(obj)) ? namespaceClass('__cell-radio--selected') : ''\">\r\n        <div class=\"ec-form__radio\">\r\n            <label class=\"ec-form__label ec-form__label--radio\">\r\n                <input type=\"radio\" name=\"{{namespaceId('radio')}}\" data-ng-checked=\"isSelected(keyFieldParsed(obj))\" data-ng-click=\"toggleSelectedRow(keyFieldParsed(obj), obj, $event, field)\" class=\"{{namespaceClass('__radio')}}\" />\r\n                <span class=\"ec-form__radio-text\"></span>\r\n            </label>\r\n        </div>\r\n    </div>\r\n</td>\r\n"
			},
			"defaultPage": 1,
			"enablePartialCheckbox": false,
			"expandAllRows": false,
			"fields": [],
			"fixedTableHeaderEnabled": false,
			"fixedTableHeaderScrollContainer": null,
			"hideCaption": false,
			"horizontalHeaderField": null,
			"keyField": null,
			"loader": {
				"enabled": false
			},
			"namespaceClass": "ec-table",
			"orientation": "vertical",
			"page": 1,
			"paginationMode": "bottom",
			"paginationWindowSize": null,
			"perPage": 2,
			"query": false,
			"responsiveEnabled": true,
			"selectByRowEnabled": false,
			"selectedItemKeys": [],
			"sharedTemplates": {},
			"sortCaseInsensitive": false,
			"sortField": null,
			"sortFunc": null,
			"sortOrder": "asc",
			"sortableFields": null,
			"sortingEnabled": true,
			"standalone": true,
			"stickyLeadBreakPoints": null,
			"stickyLeadEnabled": false,
			"stickyPaginationMode": "top",
			"swipeBehavior": "page"
		},
		"type": "ecTable"
	}
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecTable', __webpack_require__(6).ecTable);
    morningstar.asterix.meta.register('ecTable', 'allowedEvents', ['ecTableColumnSorted', 'ecTableShowLessRows', 'ecTableShowMoreRows', 'ecTableRowCollapsed', 'ecTableRowExpanded', 'ecTableRowSelected']);

    __webpack_require__(5);
    __webpack_require__(3);
    __webpack_require__(2);
    __webpack_require__(4);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ })
/******/ ]);
//# sourceMappingURL=ec-table.js.map


// WEBPACK FOOTER //
// ./components/table/build/ec-table.js